import CustomNavbar from './Components/Navbar/CustomNavbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css'
import MainNavbarMenu from './Components/Navbar/MainNavbarMenu';
import { BrowserRouter as Router, Route, Switch, Redirect, useLocation } from 'react-router-dom';
import urlMap from './data/urlMap.json';
import { RegionProvider } from './contexts/RegionContext';
import ProductsPage from './Pages/ProductsPage';
import NewsEventsPage from './Pages/NewsAndEvents/NewsEventsPage';
import HansaFlexGroupPage from './Pages/HansaFlexGroupPages/HansaFlexGroupPage';
import HomePage from './Pages/HomePage';
import Local from './Pages/NewsAndEvents/Local';
import Measurement from './Pages/NewsAndEvents/Measurement';
import LessHeadache from './Pages/NewsAndEvents/LessHeadache';

import HfFooter from './Components/HfFooter/HfFooter';
import Journey from './Pages/HansaFlexIrelandPages/Journey';
import Management from './Pages/HansaFlexIrelandPages/Management';
import GroupManagement from './Pages/HansaFlexGroupPages/GroupManagement';
import GroupHistory from './Pages/HansaFlexGroupPages/GroupHistory';
import GroupMissionStatement from './Pages/HansaFlexGroupPages/GroupMissionStatement';
import Certificates from './Pages/HansaFlexIrelandPages/Certificates';

import SixtyYearOfHansaflex from './Pages/HansaFlexGroupPages/SixtyYearOfHansaFlex';
import Careers from './Pages/Careers';
import PrivayPolicyPage from './Pages/PrivacyPolicy';
import CookieConsent from 'react-cookie-consent';
import Codeofconduct from './Pages/Codeofconduct';



import HosesAndHoseLines from './Pages/ProductPages/HosesAndHoseLines/HosesAndHoseLines';
import HydraulicHose from './Pages/ProductPages/HosesAndHoseLines/HydraulicHose';
import MetalHoses from './Pages/ProductPages/HosesAndHoseLines/MetalHoses';
import IndustrialHoses from './Pages/ProductPages/HosesAndHoseLines/IndustrialHoses';
import PerformedHoses from './Pages/ProductPages/HosesAndHoseLines/PerformedHoses';
import ExtremelyHighPerformanceHoses from './Pages/ProductPages/HosesAndHoseLines/ExtremelyHighPerformanceHoses';
import HoseLineConfigurator from './Pages/ProductPages/HosesAndHoseLines/HoseLineConfigurator';
import PtfeHoses from './Pages/ProductPages/HosesAndHoseLines/PtfeHoses';
import Accessories from './Pages/ProductPages/HosesAndHoseLines/Accessories';
import DriveAndControlTechnology from './Pages/ProductPages/DriveAndControlTechnology/DriveAndControlTechnology';
import Pumps from './Pages/ProductPages/DriveAndControlTechnology/Pumps';
import HydraulicMotor from './Pages/ProductPages/DriveAndControlTechnology/HydraulicMotor';
import Cylinder from './Pages/ProductPages/DriveAndControlTechnology/Cylinder';
import SwitchesAndSensors from './Pages/ProductPages/DriveAndControlTechnology/SwitchesAndSensors';
import ValveTechnology from './Pages/ProductPages/DriveAndControlTechnology/ValveTechnology/ValveTechnology';
import PipelineInstallationValve from './Pages/ProductPages/DriveAndControlTechnology/ValveTechnology/PipelineInstallationValve';
import CartridgeValves from './Pages/ProductPages/DriveAndControlTechnology/ValveTechnology/CartridgeValves';
import CetopValves from './Pages/ProductPages/DriveAndControlTechnology/ValveTechnology/CetopValves';
import MeasuringTechnology from './Pages/ProductPages/DriveAndControlTechnology/MeasuringTechnology';
import SevenHundredBarHydraulics from './Pages/ProductPages/DriveAndControlTechnology/SevenHundredBarHydraulics';
import PressureAccumulators from './Pages/ProductPages/DriveAndControlTechnology/PressureAccumulators';
import SealingTechnology from './Pages/ProductPages/SealingTechnology';
import Filtration from './Pages/ProductPages/Filtration';
import Pneumatics from './Pages/ProductPages/Pneumatics';
import TechnicalInformation from './Pages/ProductPages/TechnicalInformation';
import Approvals from './Pages/ProductPages/Approvals';
import Catalogues from './Pages/ProductPages/Catalogues';
import HydraulicConnectionTechnology from './Pages/ProductPages/HydraulicConnectionTechnology/HydraulicConnectionTechnology';
import HoseFittings from './Pages/ProductPages/HydraulicConnectionTechnology/HoseFittings';
import PipeFittings from './Pages/ProductPages/HydraulicConnectionTechnology/PipeFittings';
import Adapters from './Pages/ProductPages/HydraulicConnectionTechnology/Adapters';
import Couplings from './Pages/ProductPages/HydraulicConnectionTechnology/Couplings';
import BallValves from './Pages/ProductPages/HydraulicConnectionTechnology/BallValves';
import Flanges from './Pages/ProductPages/HydraulicConnectionTechnology/Flanges';
import Pipelines from './Pages/ProductPages/Pipelines/Pipelines';
import Pipebends from './Pages/ProductPages/Pipelines/Pipebends';
import ExpansionJoints from './Pages/ProductPages/Pipelines/ExpansionJoints';
import PipeendProcessing from './Pages/ProductPages/Pipelines/PipeendProcessing';

import HoseManagement from './Pages/ServicesPages/PreventativeMaintainance/HoseManagement/HoseManagement';
import FluidService from './Pages/ServicesPages/FluidManagement/FluidService';
import MobileService from './Pages/ServicesPages/MobileRapidHydraulicService';
import HydraulicAcademy from './Pages/ServicesPages/HydraulicAccademy';
import OilAnalysis from './Pages/ServicesPages/FluidManagement/OilAnalysis';
import OilFilteringAndCleaning from './Pages/ServicesPages/FluidManagement/OilFilteringAndCleaning';
import AssemblyAndInstallation from './Pages/ServicesPages/AssembellyAndInstallation/AssemblyAndInstallation';
import ModernisationAndOptimisation from './Pages/ServicesPages/AssembellyAndInstallation/ModernisationAndOptimisation';
import PlantProjectPlanningAndManagement from './Pages/ServicesPages/AssembellyAndInstallation/PlantProjectPlanningAndManagement';
import InstallationOfPipeAndHoseLineSystems from './Pages/ServicesPages/AssembellyAndInstallation/InstallationOfPipeAndHoseLineSystems';
import PreventataiveMaintainance from './Pages/ServicesPages/PreventativeMaintainance/PreventataiveMaintainance';
import ServicePackages from './Pages/ServicesPages/PreventativeMaintainance/HoseManagement/ServicePackages';
import XCodeIdentification from './Pages/ServicesPages/PreventativeMaintainance/HoseManagement/XCodeIdentification';
import XCodeManager from './Pages/ServicesPages/PreventativeMaintainance/HoseManagement/XCodeManager/XCodeManager';
import Licenses from './Pages/ServicesPages/PreventativeMaintainance/HoseManagement/XCodeManager/Licenses';
import Inspection from './Pages/ServicesPages/PreventativeMaintainance/Inspection/Inspection';
import IndustrialHoseInspection from './Pages/ServicesPages/PreventativeMaintainance/Inspection/IndustrialHoseInspection';
import DguvInspection from './Pages/ServicesPages/PreventativeMaintainance/Inspection/DguvInspection';
import LiftingPlatformsAndLoadingBridges from './Pages/ServicesPages/PreventativeMaintainance/Inspection/LiftingPlatformsAndLoadingBridges';
import RepairAndOverhaul from './Pages/ServicesPages/RepairAndOverhaul/RepairAndOverhaul';
import PressureAccumulatorsAndAssociatedSystems from './Pages/ServicesPages/RepairAndOverhaul/PressureAccumulatorsAndAssociatedSystems';
import HydraulicCylinderRepair from './Pages/ServicesPages/RepairAndOverhaul/HydraulicCylinderRepair';
import DigitalServices from './Pages/ServicesPages/Digital Services/DigitalServices';
import EDIandBMEcat from './Pages/ServicesPages/Digital Services/EDIandBMEcat';
import Scannersolutions from './Pages/ServicesPages/Digital Services/Scannersolutions';
import Production from './Pages/ServicesPages/Production/Production';
import CustomisedAssembly from './Pages/ServicesPages/Production/CustomisedAssembly';
import SeriesProduction from './Pages/ServicesPages/Production/SeriesProduction';

import Logisticssolutions from './Pages/ServicesPages/Logistics solutions/Logisticssolutions';
import Warehousemanagement from './Pages/ServicesPages/Logistics solutions/Warehousemanagement';
import Kanbandelivery from './Pages/ServicesPages/Logistics solutions/Kanbandelivery'
import Kitting from './Pages/ServicesPages/Logistics solutions/Kitting';
import Hydraulicworkshopcontainers from './Pages/ServicesPages/Logistics solutions/Hydraulicworkshopcontainers';
import Worksinworks from './Pages/ServicesPages/Logistics solutions/Worksinworks';

import Engineering from './Pages/ServicesPages/Enginnering/Engineering';
import EngineeredbyHansaflex from './Pages/ServicesPages/Enginnering/EngineeredbyHansaflex';
import Hydraulicunit from './Pages/ServicesPages/Enginnering/Hydraulicunit';
import Prototypemanufacture from './Pages/ServicesPages/Enginnering/Prototypemanufacture';
import Pressureaccumulatorinspection from './Pages/ServicesPages/Pressureaccumulatorinspection';

import WhoWeAre from './Pages/HansaFlexIrelandPages/WhoWeAre';
import ContactUs from './Pages/HansaFlexIrelandPages/ContactUs';
import AnnualReport from './Pages/HansaFlexGroupPages/AnnualReport';
import UpcomingEvents from './Pages/HansaFlexGroupPages/UpcomingEvents';
import Associations from './Pages/HansaFlexGroupPages/Associations';
import ResponsibilityAndSocialCommitments from './Pages/HansaFlexGroupPages/ResponsibilityAndSocialCommitments/ResponsibilityAndSocialCommitments';
import DonationInsteadGifts from './Pages/HansaFlexGroupPages/ResponsibilityAndSocialCommitments/DonationInsteadGifts';
import Diversity from './Pages/HansaFlexGroupPages/ResponsibilityAndSocialCommitments/Diversity';

import StickyContactBar from './Components/StickyContactBar/StickyContactBar';
import ContactPopup from './Components/ContactPopup/ContactPopup';
import ContactForm from './Pages/ContactForm/ContactForm';
import ThankYouPage from './Pages/ThankYouPage';
import CookieBanner from './Components/CookieBanner/CookieBanner';
import ChatContactIcon from './Components/ChatContactIcon/ChatContactIcon';
import ContactCTA from './Components/ContactCTA/ContactCTA';
import ServicesPage from './Pages/ServicesPages/ServicesPage';
import NotFound from './Pages/NotFound';
import SeoCanonical from './Components/SeoCanonical/SeoCanonical';

// Every legacy URL -> its new SEO path, derived from the single source of truth
// in src/data/urlMap.json. Apache serves the authoritative 301s
// (public/.htaccess); these client-side redirects only catch in-app navigation
// from a stale <Link> that a server redirect would never see.
const LEGACY_REDIRECTS = [
  ...urlMap.pages.flatMap((page) =>
    page.legacy.map((from) => ({ from, to: page.path }))
  ),
  ...urlMap.extraRedirects,
];

// The unified contact CTA belongs on every commercial page. Deriving it from the
// URL prefix means new product and service pages pick it up automatically,
// instead of having to be added to a hand-maintained list.
function ContactCTAForCommercialPages() {
  const { pathname } = useLocation();
  const isCommercial = pathname === '/products' || pathname.startsWith('/products/')
    || pathname === '/services' || pathname.startsWith('/services/');

  return isCommercial ? <ContactCTA /> : null;
}


// import CookieConsent from 'react-cookie-consent';


function App() {


  return (
    <Router>
      <RegionProvider>
        <SeoCanonical />
        <div className="App">
          <header className="App-header">
            <div className='primary-navbar'>
              <CustomNavbar />
            </div>
          </header>
          <div className='secondary-navbar sticky-top '>
            <StickyContactBar />
            <MainNavbarMenu />
          </div>
          <Switch>
            {/* Legacy URLs first, so a stale in-app link never renders a page
                at its old address and creates a duplicate. */}
            {LEGACY_REDIRECTS.map(({ from, to }) => (
              <Redirect exact key={from} from={from} to={to} />
            ))}

            <Route path="/" exact sensitive component={HomePage} />
            <Route exact sensitive path="/products" component={ProductsPage} />
            <Route exact sensitive path="/services" component={ServicesPage} />
            <Route exact sensitive path="/hansa-flex-group" component={HansaFlexGroupPage} />
            <Route exact sensitive path="/contact-us" component={ContactUs} />
            <Route exact sensitive path="/contact-form" component={ContactForm} />
            <Route exact sensitive path="/thank-you" component={ThankYouPage} />

            <Route exact sensitive path="/news-and-events" component={NewsEventsPage} />
            <Route exact sensitive path="/news-and-events/local-or-imported-hydraulic-stock" component={Local} />
            <Route exact sensitive path="/news-and-events/essential-tools-for-hydraulic-measurement" component={Measurement} />
            <Route exact sensitive path="/news-and-events/less-headache-with-maintenance-plans" component={LessHeadache} />

            <Route exact sensitive path="/about/who-we-are" component={WhoWeAre} />
            <Route exact sensitive path="/about/our-journey" component={Journey} />
            <Route exact sensitive path="/about/certificates" component={Certificates} />
            <Route exact sensitive path="/careers" component={Careers} />

            <Route exact sensitive path="/privacy-policy" component={PrivayPolicyPage} />
            <Route exact sensitive path="/about/management" component={Management} />

            <Route exact sensitive path="/hansa-flex-group/management" component={GroupManagement} />
            <Route exact sensitive path="/hansa-flex-group/history" component={GroupHistory} />
            <Route exact sensitive path="/hansa-flex-group/mission-statement-and-values" component={GroupMissionStatement} />
            <Route exact sensitive path="/hansa-flex-group/60-years-of-hansa-flex" component={SixtyYearOfHansaflex} />
            <Route exact sensitive path="/hansa-flex-group/annual-report" component={AnnualReport} />
            <Route exact sensitive path="/hansa-flex-group/upcoming-events" component={UpcomingEvents} />
            <Route exact sensitive path="/hansa-flex-group/associations" component={Associations} />
            <Route exact sensitive path="/hansa-flex-group/responsibility-and-social-commitments" component={ResponsibilityAndSocialCommitments} />
            <Route exact sensitive path="/hansa-flex-group/responsibility-and-social-commitments/donations-instead-of-gifts" component={DonationInsteadGifts} />
            <Route exact sensitive path="/hansa-flex-group/responsibility-and-social-commitments/diversity" component={Diversity} />


            {/* HF Products Pages */}
            <Route exact sensitive path="/products/hoses-and-hose-lines" component={HosesAndHoseLines} />
            <Route exact sensitive path="/products/hoses-and-hose-lines/hose-line-configurator" component={HoseLineConfigurator} />
            <Route exact sensitive path="/products/hoses-and-hose-lines/hydraulic-hoses" component={HydraulicHose} />
            <Route exact sensitive path="/products/hoses-and-hose-lines/metal-hoses" component={MetalHoses} />
            <Route exact sensitive path="/products/hoses-and-hose-lines/industrial-hoses" component={IndustrialHoses} />
            <Route exact sensitive path="/products/hoses-and-hose-lines/preformed-hoses" component={PerformedHoses} />
            <Route exact sensitive path="/products/hoses-and-hose-lines/extremely-high-pressure-hoses" component={ExtremelyHighPerformanceHoses} />
            <Route exact sensitive path="/products/hoses-and-hose-lines/ptfe-hoses" component={PtfeHoses} />
            <Route exact sensitive path="/products/hoses-and-hose-lines/hose-accessories" component={Accessories} />

            <Route exact sensitive path="/products/drive-and-control-technology" component={DriveAndControlTechnology} />
            <Route exact sensitive path="/products/drive-and-control-technology/hydraulic-pumps" component={Pumps} />
            <Route exact sensitive path="/products/drive-and-control-technology/hydraulic-motors" component={HydraulicMotor} />
            <Route exact sensitive path="/products/drive-and-control-technology/hydraulic-cylinders" component={Cylinder} />
            <Route exact sensitive path="/products/drive-and-control-technology/switches-and-sensors" component={SwitchesAndSensors} />
            <Route exact sensitive path="/products/drive-and-control-technology/valve-technology" component={ValveTechnology} />
            <Route exact sensitive path="/products/drive-and-control-technology/valve-technology/pipeline-installation-valves" component={PipelineInstallationValve} />
            <Route exact sensitive path="/products/drive-and-control-technology/valve-technology/cartridge-valves" component={CartridgeValves} />
            <Route exact sensitive path="/products/drive-and-control-technology/valve-technology/cetop-valves" component={CetopValves} />
            <Route exact sensitive path="/products/drive-and-control-technology/measuring-technology" component={MeasuringTechnology} />
            <Route exact sensitive path="/products/drive-and-control-technology/700-bar-heavy-load-hydraulics" component={SevenHundredBarHydraulics} />
            <Route exact sensitive path="/products/drive-and-control-technology/pressure-accumulators" component={PressureAccumulators} />

            <Route exact sensitive path="/products/hydraulic-connection-technology" component={HydraulicConnectionTechnology} />
            <Route exact sensitive path="/products/hydraulic-connection-technology/hose-fittings" component={HoseFittings} />
            <Route exact sensitive path="/products/hydraulic-connection-technology/pipe-fittings" component={PipeFittings} />
            <Route exact sensitive path="/products/hydraulic-connection-technology/adapters" component={Adapters} />
            <Route exact sensitive path="/products/hydraulic-connection-technology/couplings" component={Couplings} />
            <Route exact sensitive path="/products/hydraulic-connection-technology/ball-valves" component={BallValves} />
            <Route exact sensitive path="/products/hydraulic-connection-technology/flanges" component={Flanges} />

            <Route exact sensitive path="/products/sealing-technology" component={SealingTechnology} />
            <Route exact sensitive path="/products/filtration" component={Filtration} />
            <Route exact sensitive path="/products/pneumatics" component={Pneumatics} />
            <Route exact sensitive path="/products/technical-information" component={TechnicalInformation} />
            <Route exact sensitive path="/products/approvals" component={Approvals} />
            <Route exact sensitive path="/products/catalogues" component={Catalogues} />

            <Route exact sensitive path="/products/pipelines" component={Pipelines} />
            <Route exact sensitive path="/products/pipelines/pipe-bends" component={Pipebends} />
            <Route exact sensitive path="/products/pipelines/pipe-end-processing" component={PipeendProcessing} />
            <Route exact sensitive path="/products/pipelines/expansion-joints" component={ExpansionJoints} />

            {/* HF Services Pages */}
            <Route exact sensitive path="/services/preventative-maintenance/hose-management" component={HoseManagement} />
            <Route exact sensitive path="/services/mobile-rapid-hydraulic-service" component={MobileService} />
            <Route exact sensitive path="/services/hydraulic-training-and-seminars" component={HydraulicAcademy} />

            <Route exact sensitive path="/services/fluid-management" component={FluidService} />
            <Route exact sensitive path="/services/fluid-management/oil-analysis" component={OilAnalysis} />
            <Route exact sensitive path="/services/fluid-management/oil-filtering-and-cleaning" component={OilFilteringAndCleaning} />

            <Route exact sensitive path="/services/assembly-and-installation" component={AssemblyAndInstallation} />
            <Route exact sensitive path="/services/assembly-and-installation/modernisation-and-optimisation" component={ModernisationAndOptimisation} />
            <Route exact sensitive path="/services/assembly-and-installation/plant-project-planning-and-management" component={PlantProjectPlanningAndManagement} />
            <Route exact sensitive path="/services/assembly-and-installation/installation-of-pipe-and-hose-line-systems" component={InstallationOfPipeAndHoseLineSystems} />

            <Route exact sensitive path="/services/preventative-maintenance" component={PreventataiveMaintainance} />
            <Route exact sensitive path="/services/preventative-maintenance/hose-management/service-packages" component={ServicePackages} />
            <Route exact sensitive path="/services/preventative-maintenance/hose-management/x-code-hose-identification-system" component={XCodeIdentification} />
            <Route exact sensitive path="/services/preventative-maintenance/hose-management/x-code-manager" component={XCodeManager} />
            <Route exact sensitive path="/services/preventative-maintenance/hose-management/x-code-manager-licences" component={Licenses} />
            <Route exact sensitive path="/services/preventative-maintenance/inspections" component={Inspection} />
            <Route exact sensitive path="/services/preventative-maintenance/inspections/industrial-hose-inspection" component={IndustrialHoseInspection} />
            <Route exact sensitive path="/services/preventative-maintenance/inspections/dguv-inspection" component={DguvInspection} />
            <Route exact sensitive path="/services/preventative-maintenance/inspections/lifting-platforms-and-loading-bridges" component={LiftingPlatformsAndLoadingBridges} />

            <Route exact sensitive path="/services/repair-and-overhaul" component={RepairAndOverhaul} />
            <Route exact sensitive path="/services/repair-and-overhaul/hydraulic-cylinder-repair" component={HydraulicCylinderRepair} />
            <Route exact sensitive path="/services/repair-and-overhaul/pressure-accumulators-and-associated-systems" component={PressureAccumulatorsAndAssociatedSystems} />

            <Route exact sensitive path="/services/digital-services" component={DigitalServices} />
            <Route exact sensitive path="/services/digital-services/edi-and-bmecat" component={EDIandBMEcat} />
            <Route exact sensitive path="/services/digital-services/scanner-solutions" component={Scannersolutions} />
            <Route exact sensitive path="/services/production" component={Production} />
            <Route exact sensitive path="/services/production/customised-assembly" component={CustomisedAssembly} />
            <Route exact sensitive path="/services/production/series-production" component={SeriesProduction} />

            <Route exact sensitive path="/services/logistics-solutions" component={Logisticssolutions} />
            <Route exact sensitive path="/services/logistics-solutions/warehouse-management" component={Warehousemanagement} />
            <Route exact sensitive path="/services/logistics-solutions/kanban-delivery" component={Kanbandelivery} />
            <Route exact sensitive path="/services/logistics-solutions/kitting" component={Kitting} />
            <Route exact sensitive path="/services/logistics-solutions/hydraulic-workshop-containers" component={Hydraulicworkshopcontainers} />
            <Route exact sensitive path="/services/logistics-solutions/works-in-works" component={Worksinworks} />

            <Route exact sensitive path="/services/engineering" component={Engineering} />
            <Route exact sensitive path="/services/engineering/engineered-by-hansa-flex" component={EngineeredbyHansaflex} />
            <Route exact sensitive path="/services/engineering/hydraulic-unit-manufacture" component={Hydraulicunit} />
            <Route exact sensitive path="/services/engineering/prototype-manufacture" component={Prototypemanufacture} />
            <Route exact sensitive path="/code-of-conduct" component={Codeofconduct} />
            <Route exact sensitive path="/services/preventative-maintenance/inspections/pressure-accumulator-inspection" component={Pressureaccumulatorinspection} />


            {/* Anything else is a genuine 404, never a blank page returning 200. */}
            <Route component={NotFound} />
          </Switch>

          {/* Unified contact CTA on every product and service page. */}
          <ContactCTAForCommercialPages />

          <div>
            <HfFooter />
          </div>

          {/* Contact Popup - appears after 3 seconds */}
          <ContactPopup />

          {/* Chat Contact Icon - floating contact button */}
          <ChatContactIcon />

          <CookieBanner />
        </div>
      </RegionProvider>
    </Router>
  );
}

export default App;
